import React from 'react';

export default function Logo(props) {
  return (
    <span className="logo" {...props}>
      {/* Use your site favicon inside the badge */}
      <span className="logo-badge" style={{ display: 'grid', placeItems: 'center', overflow: 'hidden' }}>
        <img
          src="/favicon.svg"          /* if your favicon is .png, change to /favicon.png */
          alt="CareerMove icon"
          width="20"
          height="20"
          style={{ width: 20, height: 20, objectFit: 'contain', display: 'block' }}
        />
      </span>
      <span className="logo-text">CareerMove</span>
    </span>
  );
}
